<template>
    <!-- The Modal -->
    <b-modal
            id="recommended-vehicle-model"
            :title="recommend ? 'Recommend Vehicle' : 'Send Email'"
            v-model="modalOpen"
            no-fade
            size="lg"
            @change="onModalChange"
            @hide="onModalChange"
            @show="onModalChange">
        <template v-slot:modal-footer>
            <b-btn @click="modalOpen = false">Cancel</b-btn>
            <b-btn :disabled="!selectedUserIds.length ? (customRecipients === '') ? true : false : false" :title="selectedUserIds.length ? '' : 'Add some users to send.'" @click="submitRecommendation()">Send</b-btn>
        </template>
        <div class="">
            Select the people you want to recommend this car to.
        </div>
        <template v-if="recommend">
            <span class="checkbox">
                <input type="checkbox" name="notify" id="notify" v-model="notify"/>
                <label for="notify">Also notify customers by email</label>
            </span>
        </template>
        <div v-if="notify" class="modal-container-message">
            <div class="row">
                <div class="col-md-12">
                    <p class="hello">Hi {first_name}, </p>
                    <textarea name="emailMessage" id="emailMessage" v-model="notifyMessage" style="height: 100px !important;">
                        {{ notifyMessage }}
                    </textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 input-area">
                <label for="custom-recipients">
                    Send To
                    <a v-if="$userIsAdmin()" v-b-toggle.collapse-email-input>[new email]</a>
                </label>
                <b-collapse id="collapse-email-input" :visible="!$userIsAdmin()">
                    <input
                        type="text"
                        name="userName"
                        placeholder="Input emails separated by commas."
                        id="custom-recipients"
                        v-model="customRecipients"
                        class="textbox"
                    />
                </b-collapse>
            </div>
        </div>
        <b-table
                v-if="$userIsAdmin() && viewListOfUsers"
                class="list-table"
                :sort-by.sync="sort_by"
                :sort-desc.sync="sort_desc"
                :fields="fields"
                :items="users"
                show-empty
        >
            <template v-slot:empty="scope">
                Search below to add users.
            </template>
            <template v-slot:cell(checkbox)="data">
                <icon icon="fa-times text-danger" class="cursor-pointer" @click="removeUser(data.item.id)" title="Remove from list"></icon>
            </template>
            <template v-slot:cell(region)="data">
                <span v-if="data.item.region && data.item.region.name">{{data.item.region.name}}</span>
            </template>
            <template v-slot:cell(company)="data">
                <span v-if="data.item.company && data.item.company.name">{{data.item.company.name}}</span>
            </template>
            <template v-slot:cell(assignedrep)="data">
                <span v-if="data.item.sales_rep && data.item.sales_rep.name">{{data.item.sales_rep.name}}</span>
            </template>
        </b-table>
        <div v-if="$userIsAdmin()">
            <div class="row">
                <div class="col-md-12 mb-1">
                    <input
                        ref="user_search_input"
                        type="email"
                        name="userName"
                        placeholder="Start typing to search"
                        v-on:keyup="getUsers()"
                        id="userName"
                        v-model="userName"
                        class="textbox"
                    />
                </div>
            </div>
            <template>
                <span class="checkbox">
                    <input type="checkbox" name="sales_rep" id="sales-rep" v-model="salesRep" @input="getUsers()"/>
                    <label for="sales-rep">Filter by Sales Rep</label>
                </span>
            </template>
            <div class="row user-detail" v-if="getUserList">
                <div class="col-md-12" v-for="user in getUserList">
                    <div class="row detail">
                        <div class="col-md-6">
                            <span class="member-name">{{user.name}}</span> <span
                            v-if="user.company">({{user.company.name}})</span>
                        </div>
                        <div class="col-md-6 link">
                            <a @click="saveToList(user)" class="save-list">Add</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import {arrayChunk, objLookup} from '../util/common'
    export default {
        props: {
            selectedVehicles : [String, Number, Boolean, Array],
            vehicle_id : Number,
            cacheKey : String,
            recommend : Boolean,
            value : [String, Number, Boolean, Array],
            notifyMessage : {
                default: 'default',
                type: String
            },
        },
        created(){
            this.$store.dispatch('users/getUsers', {args: {
                    sort_by: 'company_id',
                    sort_asc: true,
                    per_page: 1000,
                    filter_by_status: 1,
                }});
            if (!this.recommend) {
                this.notify = true;
            }
        },
        mounted(){
          this.pustVehicleToArray()
        },
        data() {
            return {
                sort_by: 'first_name',
                userName: '',
                customRecipients: '',
                userSearchCancelToken: null,
                sort_desc: false,
                modalOpen: this.value,
                selected_search: null,
                salesRep: false,
                fields: [
                    {label: '',      key: 'checkbox'},
                    {label: 'Company',      key: 'company'},
                    {label: 'Name',         key: 'name'},
                    {label: 'Region',       key: 'region'},
                    {label: 'Assigned Rep', key: 'assignedrep'},
                ],
                notify: false,
                selectedUserIds: [],
                viewListOfUsers: true,
                getUserList: [],
                users: [],
                vehicleIds: []
            }
        },
        computed: {
            ...mapState({
                // users: state => state.users.all,
                total: state => state.users.total,
            }),
            selectAll(){
                return this.selectedUserIds.length === this.users.length
            },
        },
        watch: {
            value(){
                this.modalOpen = !!this.value;
            }
        },
        methods: {
            onSelectAllClick(){
                if (this.selectAll) {
                    this.selectedUserIds = []
                } else {
                    let uids = []
                    this.users.forEach(user => {
                        uids.push(user.id)
                    })
                    this.selectedUserIds = uids
                }
            },
            objLookup(obj, key){
                return objLookup(obj, key);
            },
            onModalChange(){
                this.$emit('input', this.modalOpen);
            },
            submitRecommendation(){
                let vehicleIdArray = []
                if(this.vehicleIds && this.vehicleIds.length > 0){
                    vehicleIdArray = this.vehicleIds
                } else{
                    vehicleIdArray = this.selectedVehicles
                }
                this.$store.dispatch('users/storeRecommendation', {
                    user_ids: this.selectedUserIds,
                    custom_recipients: this.customRecipients,
                    vehicle_ids: vehicleIdArray,
                    notify: this.notify,
                    recommend: this.recommend,
                    cache_key: this.cacheKey,
                    notify_message: this.notifyMessage,
                }).then(res => {
                    this.$notify({
                        title: 'Success',
                        message: res.message || 'Recommendation successful.',
                        type: 'success'
                    });
                    this.modalOpen = false;
                }).catch(err => {
                    console.warn('err', err)
                    this.modalOpen = false;
                    this.$notify({
                        title: 'Error',
                        message: res.message || 'Recommendation failed.',
                        type: 'error'
                    });
                });
               return false;
            },

            getUsers(){
                if (this.userName) {

                    if (this.userSearchCancelToken) {
                        this.userSearchCancelToken.cancel('Request cancelled for new request')
                    }
                    this.userSearchCancelToken = this.axios.CancelToken.source();
                    this.$store.dispatch('users/getUsers', {
                        args: {
                            searchUser: this.userName,
                            filter_by_statuses: [1,2,3],
                            filter_by_sales_rep: this.salesRep,
                            sort_asc: 1
                        },
                        cancelToken: this.userSearchCancelToken
                    }).then(response => {
                        let users = []
                        response.data.forEach(user => {
                            if (this.selectedUserIds.indexOf(user.id) === -1) {
                                users.push(user)
                            }
                        })
                        this.getUserList = users
                    }).catch(e => console.warn('VehicleRecommendationModal/getUsers catch', e));;
                } else {
                    this.getUserList = [];
                }
            },
            resetRecommendedUser(){
                this.selectedUserIds = [];
            },
            researchForPerson(){
                this.viewListOfUsers = true;
            },
            pustVehicleToArray(){
                if(this.vehicle_id){
                    this.vehicleIds.push(this.vehicle_id)
                }

            },
            removeUser(user_id){
                let found_index = null
                this.users.forEach((user, index) => {
                    if (user.id === user_id) {
                        found_index = index
                    }
                })
                if (found_index !== null) {
                    this.users.splice(found_index, 1)
                }
                this.updateSelectedUserIds()
            },
            saveToList(user){
                this.users.push(user)
                this.getUserList = this.getUserList.filter((u) => {
                    return u.id !== user.id
                })
                this.updateSelectedUserIds()
            },
            updateSelectedUserIds(){
                let ids = [];
                this.users.forEach(user => {
                    ids.push(user.id)
                })
                this.selectedUserIds = ids
            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleRecommendationModal.vue